// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"232":"d1a088f7","368":"d7f0ec83","424":"75386a07","924":"0470a97e","984":"28f34694"}[chunkId] + ".chunk.js";
};